module.exports = __webpack_public_path__ + "img/bg.5e5dcc15.jpg";